import React from 'react';

const Users = () => <div>Users Page</div>;

export default Users; 